// New Concept Chile — agrega productos al carro real de Shopify (Ajax Cart API).
//
// El contador del carrito y la apertura del cajon ("drawer") se avisan con el
// evento nativo 'cart:update' que ya escuchan los componentes propios del tema
// (cart-icon, cart-drawer-component) -- NUNCA se reemplaza el header completo
// para esto. Antes se hacia fetch de la seccion del header y se reemplazaba su
// nodo entero (replaceChild) para refrescar el contador; eso destruia y volvia
// a crear el menu de navegacion (header-menu / overflow-list), que mide su
// ancho disponible al conectarse. Esa remedicion, justo mientras el cajon del
// carrito se abre (lo que cambia el ancho visible al ocultar el scroll de la
// pagina), calculaba mal cuantos items entraban y colapsaba casi todo el menu
// dentro del boton "Mas". Al avisar solo con el evento nativo, el menu nunca
// se toca y el bug desaparece.

function ncNotifyCartUpdate(itemCountAdded) {
  document.dispatchEvent(new CustomEvent('cart:update', {
    bubbles: true,
    detail: {
      resource: null,
      sourceId: 'nc-theme',
      data: {
        itemCount: itemCountAdded,
        source: 'product-form-component'
      }
    }
  }));
  var drawer = document.querySelector('cart-drawer-component');
  if (drawer && typeof drawer.open === 'function') drawer.open();
}

document.addEventListener('click', function (e) {
  var btn = e.target.closest('.nc-add-to-cart');
  if (!btn) return;
  var variantId = btn.getAttribute('data-variant-id');
  var title = btn.getAttribute('data-product-title') || 'Producto';
  var section = btn.closest('.nc-section');
  var toast = section ? section.querySelector('.nc-toast') : null;

  function showToast(text) {
    if (!toast) return;
    toast.textContent = text;
    toast.classList.add('nc-show');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('nc-show'); }, 2400);
  }

  if (!variantId) return;
  if (btn.dataset.ncBeltUrl) { window.location.assign(btn.dataset.ncBeltUrl + '?variant=' + encodeURIComponent(variantId) + '#nc-belt-adjustment'); return; }
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
    .then(function (result) {
      btn.disabled = false;
      if (result.ok) {
        showToast('Añadido al carrito: ' + title);
        ncNotifyCartUpdate(1);
      } else {
        showToast(result.data && result.data.description ? result.data.description : 'No se pudo añadir al carrito.');
      }
    })
    .catch(function () {
      btn.disabled = false;
      showToast('No se pudo añadir al carrito. Intenta de nuevo.');
    });
});

// "Comprar ahora" — agrega el producto y va directo al checkout, sin pasar por el carrito.
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.nc-buy-now');
  if (!btn) return;
  var variantId = btn.getAttribute('data-variant-id');
  if (!variantId) return;
  if (btn.dataset.ncBeltUrl) { window.location.assign(btn.dataset.ncBeltUrl + '?variant=' + encodeURIComponent(variantId) + '#nc-belt-adjustment'); return; }
  var section = btn.closest('.nc-section');
  var toast = section ? section.querySelector('.nc-toast') : null;

  function showToast(text) {
    if (!toast) return;
    toast.textContent = text;
    toast.classList.add('nc-show');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('nc-show'); }, 2400);
  }

  btn.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
    .then(function (result) {
      if (result.ok) {
        window.location.href = '/checkout';
      } else {
        btn.disabled = false;
        showToast(result.data && result.data.description ? result.data.description : 'No se pudo procesar la compra.');
      }
    })
    .catch(function () {
      btn.disabled = false;
      showToast('No se pudo procesar la compra. Intenta de nuevo.');
    });
});

// Selector de color en la tarjeta de producto (grillas de colección / destacados):
// al hacer clic en un swatch, cambia la imagen, el precio y el variant-id que usan
// los botones de "añadir"/"comprar ahora" de esa misma tarjeta, sin recargar ni navegar.
document.addEventListener('click', function (e) {
  var sw = e.target.closest('.nc-swatch');
  if (!sw) return;
  var card = sw.closest('.nc-prod-card');
  if (!card) return;

  card.querySelectorAll('.nc-swatch').forEach(function (s) { s.classList.remove('nc-swatch-active'); });
  sw.classList.add('nc-swatch-active');

  var variantId = sw.getAttribute('data-variant-id');
  var addBtn = card.querySelector('.nc-add-to-cart');
  var buyBtn = card.querySelector('.nc-buy-now');
  if (addBtn && variantId) addBtn.setAttribute('data-variant-id', variantId);
  if (buyBtn && variantId) buyBtn.setAttribute('data-variant-id', variantId);

  var imgUrl = sw.getAttribute('data-image');
  var img = card.querySelector('.nc-prod-media img');
  if (img && imgUrl) {
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = imgUrl;
  }

  var price = sw.getAttribute('data-price');
  var priceEl = card.querySelector('.nc-now');
  if (priceEl && price) priceEl.textContent = price;
});

// Precarga en segundo plano las imágenes de todas las variantes de color de las
// tarjetas visibles, para que al hacer clic en un swatch la foto cambie al instante
// en vez de demorar ~2s en descargarse la primera vez (mismo patrón que en la
// página de producto individual).
function ncPreloadSwatchImages() {
  document.querySelectorAll('.nc-swatch').forEach(function (sw) {
    if (sw.dataset.preloaded === 'true') return;
    var url = sw.getAttribute('data-image');
    if (!url) return;
    sw.dataset.preloaded = 'true';
    var pre = new Image();
    pre.src = url;
  });
}

if ('requestIdleCallback' in window) {
  window.requestIdleCallback(ncPreloadSwatchImages, { timeout: 2000 });
} else {
  setTimeout(ncPreloadSwatchImages, 300);
}

document.addEventListener('shopify:section:load', function () {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(ncPreloadSwatchImages, { timeout: 2000 });
  } else {
    setTimeout(ncPreloadSwatchImages, 300);
  }
});

// Popup de personalizacion: productos de la coleccion "joyeria-personalizable"
// muestran un boton distinto en la tarjeta (.nc-personalize-btn). Se probo insertar
// ahi mismo el formulario completo de grabado de la app Optis Product Options, pero
// su script produce un error real ("Cannot read properties of undefined") y un 400
// al agregar al carrito -- la app solo soporta ese formulario dentro de la ficha del
// producto real, no en un popup aparte (ver nota en layout/theme.liquid). Por eso el
// popup ofrece dos caminos seguros: ir a la ficha del producto a personalizar, o
// anadirlo directo al carrito sin personalizar.
(function () {
  function getOverlay() { return document.getElementById('nc-personalize-overlay'); }

  function openPersonalizeModal(variantId, productUrl) {
    var overlay = getOverlay();
    if (!overlay) return;
    var gotoLink = document.getElementById('nc-personalize-goto');
    if (gotoLink) gotoLink.href = productUrl || '#';
    overlay.dataset.variantId = variantId || '';
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closePersonalizeModal() {
    var overlay = getOverlay();
    if (!overlay) return;
    overlay.hidden = true;
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('.nc-personalize-btn');
    if (openBtn) {
      openPersonalizeModal(openBtn.getAttribute('data-variant-id'), openBtn.getAttribute('data-product-url'));
      return;
    }

    var overlay = getOverlay();
    if (overlay && !overlay.hidden && (e.target.closest('.nc-personalize-close') || e.target === overlay)) {
      closePersonalizeModal();
      return;
    }

    var skipBtn = e.target.closest('.nc-personalize-skip');
    if (skipBtn) {
      var variantId = overlay ? overlay.dataset.variantId : (getOverlay() ? getOverlay().dataset.variantId : '');
      if (!variantId) return;
  if (btn.dataset.ncBeltUrl) { window.location.assign(btn.dataset.ncBeltUrl + '?variant=' + encodeURIComponent(variantId) + '#nc-belt-adjustment'); return; }
      skipBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          skipBtn.disabled = false;
          if (result.ok) {
            closePersonalizeModal();
            ncNotifyCartUpdate(1);
          }
        })
        .catch(function () { skipBtn.disabled = false; });
    }
  });

  document.addEventListener('keydown', function (e) {
    var overlay = getOverlay();
    if (e.key === 'Escape' && overlay && !overlay.hidden) closePersonalizeModal();
  });
})();
